<template>
  <el-row class="warp">
    <el-col :span="24" class="warp-main" v-loading="loading" element-loading-text="拼命加载中">
      <!--查找-->
      <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
        <el-form :inline="true" :model="filters" :rules="filtersRules" ref="filters">
          <el-form-item label="中心名称:" prop="shopname">
            <el-input v-model="filters.shopname" placeholder="中心名称" style="min-width: 120px"
              @keyup.enter.native="clickSearch('filters')"></el-input>
          </el-form-item>

          <el-form-item label="ERP编号:" prop="erpno">
            <el-input v-model="filters.erpno" placeholder="erp编号" style="min-width: 100px"></el-input>
          </el-form-item>

          <el-form-item label="营业状态:" prop="isdelete">
            <el-select v-model="filters.isdelete" placeholder="请选择状态">
              <el-option v-for="item in optionState" :key="item.value" :label="item.label" :value="item.value" />
            </el-select>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="clickSearch('filters')">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="showAddDialog">增加</el-button>
          </el-form-item>
          <el-form-item>
            <el-button @click="gotopage">重置</el-button>
          </el-form-item>
          <el-form-item>
            <el-button type="success" @click="excelSearch('filters')">导出</el-button>
          </el-form-item>

          <el-collapse  accordion>
            <el-collapse-item>
              <template slot="title">
                <el-button type="text">更多条件<i class="header-icon el-icon-search"></i></el-button>
              </template>
              <el-row>
                <el-form-item label="开店时间:">
                  <el-date-picker v-model="value1" type="daterange" range-separator="至" start-placeholder="开始日期"
                    end-placeholder="结束日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="电子邮箱:" prop="email">
                  <el-input type="email" v-model="filters.email" placeholder="电子邮箱"></el-input>
                </el-form-item>
                <el-form-item label="公司名称:" prop="companyname">
                  <el-input v-model="filters.companyname" placeholder="公司名称"></el-input>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="所属城市:">
                  <el-cascader size="large" :options="options" v-model="selectedOptions" @change="handleChange">
                  </el-cascader>
                </el-form-item>
              </el-row>
            </el-collapse-item>
          </el-collapse>

        </el-form>
      </el-col>
      <!--列表-->
      <el-table :data="shops" highlight-current-row v-loading="loading" border style="width: 100%">
        <el-table-column type="index" label="序号"></el-table-column>
        <el-table-column prop="id" label="店ID" min-width="60"></el-table-column>
        <el-table-column prop="shopname" label="中心名称" min-width="140"></el-table-column>
        <el-table-column prop="tel" label="联系电话" min-width="120"></el-table-column>
        <el-table-column width="100px" prop="isdelete" label="营业状态" :formatter="formatIsdelete">
        </el-table-column>
        <el-table-column prop="datestart" label="开店时间" min-width="140">
          <template slot-scope="scope">{{
            scope.row.datestart | Time
          }}</template>
        </el-table-column>
        <el-table-column prop="erpno" label="erp编号" min-width="120"></el-table-column>
        <el-table-column prop="province" label="省份"></el-table-column>
        <el-table-column prop="city" label="城市"></el-table-column>
        <el-table-column prop="address" label="详细地址" min-width="240"></el-table-column>
        <el-table-column prop="companyname" label="公司名称" min-width="180"></el-table-column>
        <el-table-column prop="email" label="电子邮件" min-width="120"></el-table-column>
        <el-table-column fixed="right" label="操作" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="showEditDialog(scope.$index, scope.row)">编辑</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--分页-->
      <el-col :span="24" class="toolbar">
        <el-pagination layout="total, prev, pager, next" @current-change="handleCurrentChange" :page-size="10"
          :total="total" style="float: right">
        </el-pagination>
      </el-col>
      <!-- 添加界面 -->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form :model="addForm" label-width="80px" :rules="addFormRules" ref="addForm" show-overflow-tooltip>
          <el-form-item label="中心名称" prop="shopname">
            <el-input v-model="addForm.shopname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="ERP编号" prop="erpno">
            <el-input v-model="addForm.erpno" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="开店时间" prop="datestart">
            <el-date-picker type="date" placeholder="开店时间" v-model="addForm.datestart"></el-date-picker>
          </el-form-item>
          <el-form-item label="对应省市">
            <el-cascader size="large" :options="addoptions" v-model="addselectedOptions" @change="addhandleChange">
            </el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="addForm.address" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="tel">
            <el-input v-model="addForm.tel" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyname">
            <el-input v-model="addForm.companyname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电子邮件" prop="email">
            <el-input v-model="addForm.email"></el-input>
          </el-form-item>

          <el-form-item label="备注" prop="info">
            <el-input type="textarea" v-model="addForm.info"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交
          </el-button>
          <el-button @click.native="addFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
      <!-- 编辑界面 -->
      <el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false">
        <el-form :model="editForm" label-width="80px" :rules="editFormRules" ref="editForm" show-overflow-tooltip>
          <el-form-item label="中心名称" prop="shopname">
            <el-input v-model="editForm.shopname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="ERP编号" prop="erpno">
            <el-input v-model="editForm.erpno" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="开店时间" prop="datestart">
            <el-date-picker type="date" placeholder="开店时间" v-model="editForm.datestart"></el-date-picker>
          </el-form-item>
          <el-form-item label="对应省市">
            <el-cascader size="large" :options="editoptions" v-model="editselectedOptions" @change="edithandleChange">
            </el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="editForm.address" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="联系电话" prop="tel">
            <el-input v-model="editForm.tel" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="公司名称" prop="companyname">
            <el-input v-model="editForm.companyname" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="电子邮件" prop="email">
            <el-input v-model="editForm.email"></el-input>
          </el-form-item>
          <el-form-item label="营业状态" prop="isdelete">
            <el-radio-group v-model="editForm.isdelete">
              <el-radio :label="0">营业中</el-radio>
              <el-radio :label="1">已闭店</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" prop="info">
            <el-input type="textarea" v-model="editForm.info"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click.native="editSubmit" :loading="addLoading">提交
          </el-button>
          <el-button @click.native="editFormVisible = false">取消</el-button>
        </div>
      </el-dialog>
    </el-col>
  </el-row>
</template>

<script>
import API from "../../api/shop/shop";
import {
  provinceAndCityData,
  regionData,
  provinceAndCityDataPlus,
  regionDataPlus,
  CodeToText,
  TextToCode,
} from "element-china-area-data";
import { validateEMail, validatePhoneTwo } from "../../utils/validators";
export default {
  inject: ['reload'],
  data() {
    return {
      optionState: [
        {
          value: "0",
          label: "营业中",
        },
        {
          value: "1",
          label: "已闭店",
        },
        {
          value: "-1",
          label: "全部",
        },
      ],
      options: regionDataPlus,
      selectedOptions: [],

      addoptions: regionDataPlus,
      addselectedOptions: [],

      editoptions: regionDataPlus,
      editselectedOptions: [],
      filters: {
        name: "",

        type: 0, //默认为0，当点击搜索触发的时候变为1
      },
      filtersRules: {
        mobile: [
          {
            required: true,
            message: "请输入正确的电话号码或者固话号码",
            trigger: "blur",
          },
          { validator: validatePhoneTwo },
        ],
      },
      loading: false,
      shops: [],
      roles: [],
      roleIds: [],
      total: 0,
      page: 1,
      limit: 10,
      value1: "",
      selprovince: "",
      selcity: "",
      selcountry: "",

      //   addselprovince:"",
      //   addselcity:"",
      //   addselcountry:"",

      //新增相关数据
      addFormVisible: false, //新增界面是否显示
      addLoading: false,
      addFormRules: {
        shopname: [
          { required: true, message: "请输入中心名称", trigger: "blur" },
        ],
        datestart: [
          { required: true, message: "请选择开店时间", trigger: "blur" },
        ],
        email: [{ validator: validateEMail }],
        email: [{ required: true, message: "请输入电子邮件", trigger: "blur" }],
        Provincelist: {
          type: "array",
          required: true,
          message: "请选择省市区",
          trigger: "change",
        },

        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" },
        ],
        tel: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          { validator: validatePhoneTwo },
        ],
      },
      addForm: {
        shopname: "",
        datestart: "",
        province: "",
        city: "",
        country: "",
        address: "",
        tel: "",
        email: "",
        companyname: "",
        info: "",
      },

      //编辑相关数据
      editFormVisible: false,
      editFormRules: {
        name: [{ required: true, message: "请输入会员姓名", trigger: "blur" }],
        mobile: [
          { required: true, message: "请输入手机号码", trigger: "blur" },
          { min: 11, message: "手机号格式不正确", trigger: "blur" },
        ],
        birth: [
          {
            required: true,
            message: "请选择日期",
            trigger: "change",
          },
        ],
        address: [{ required: true, message: "请选则地址", trigger: "blur" }],
      },
      editForm: {
        shopname: "",
        datestart: "",
        province: "",
        city: "",
        country: "",
        address: "",
        tel: "",
        email: "",
        companyname: "",
        info: "",
      },
    };
  },
  filters: {
    // 时间格式的转换
    Time(value) {
      if (typeof value === "undefined") {
        return;
      }

      var dateee = new Date(value).toJSON();
      var date = new Date(+new Date(dateee) + 8 * 3600 * 1000)
        .toISOString()
        .replace(/T/g, " ")
        .replace(/\.[\d]{3}Z/, "");
      return date;
    },
  },
  methods: {
    gotopage() {
      //  this.$router.push('index?'+Math.random());
      this.reload();
    },
    formatIsdelete: function (row, column) {
      return row.isdelete == 0
        ? "营业中"
        : row.isdelete == 1
          ? "已闭店"
          : "未知";
    },
    handleChange(value) {
      if (value != null && value != "") {
        this.selprovince = CodeToText[value[0]];
        if (value[1] != null && value[1] != "") {
          this.selcity = CodeToText[value[1]];
        }
        if (value[2] != null && value[2] != "") {
          this.selcountry = CodeToText[value[2]];
        }
      }
    },
    addhandleChange(value) {
      if (value != null && value != "") {
        this.addForm.province = CodeToText[value[0]];
        if (value[1] != null && value[1] != "") {
          this.addForm.city = CodeToText[value[1]];
        }
        if (value[2] != null && value[2] != "") {
          this.addForm.country = CodeToText[value[2]];
        }
      }
    },
    edithandleChange(value) {
      if (value != null && value != "") {
        this.editForm.province = CodeToText[value[0]];
        if (value[1] != null && value[1] != "") {
          this.editForm.city = CodeToText[value[1]];
        }
        if (value[2] != null && value[2] != "") {
          this.editForm.country = CodeToText[value[2]];
        }
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      this.search();
    },
    handleSizeChange(val) {
      this.limit = val;
      this.search();
    },
    handleSearch() {
      this.total = 0;
      this.page = 1;
      this.search();
    },
    //点击按钮查询
    clickSearch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.total = 0;
          this.page = 1;
          this.filters.type = 1;
          this.search();
        }
      });
    },
    excelSearch(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.total = 0;
          this.page = 1;
          this.filters.type = 1;
          this.searchbyexcel();
        }
      });
    },
    clickAdd() {
      //
      this.$router.push("/sys/frbasicmember");
    },

    search: function () {
      let that = this;
      // console.log(this.value1.toString()+'---店原始时间哟');
      let datevaluestart = "";
      let datevalueend = "";
      if (this.value1.toString() == "") {
        console.log(this.value1.toString() + "---店没选时间哟");
      } else {
        console.log(this.value1.toString() + "---店已选时间哟");
        datevaluestart = this.dateFormat(this.value1.toString().split(",")[0]);
        datevalueend = this.dateFormat(this.value1.toString().split(",")[1]);
      }
      let params = {
        pageNum: that.page,
        pageSize: 10,
        shopname: that.filters.shopname,
        isdelete: that.filters.isdelete,
        province: this.selprovince,
        city: this.selcity,
        country: this.selcountry,
        email: that.filters.email,
        // value:
        //   this.dateFormat(this.value1.toString().split(",")[0]) +
        //   "," +
        //   this.dateFormat(this.value1.toString().split(",")[1]),
        datestart: datevaluestart,
        dateend: datevalueend,
        companyname: that.filters.companyname,
        erpno: that.filters.erpno,
      };

      that.loading = true;
      API.getPageList(params)
        .then(
          function (result) {
            that.loading = false;
            console.log(
              "哇卡卡走到这没" + JSON.stringify(result.data.totalSize)
            );
            if (result.data.totalSize == 0) {
              console.log("判断判断" + result.data.totalSize);
              that.shops = undefined;
            }
            if (result && result.data.totalSize) {
              that.total = result.data.totalSize;
              console.log(that.total + "--所有条数");
              that.shops = result.data.content;
            }
          },
          function (err) {
            that.loading = false;
            that.$message.error({
              showClose: true,
              message: err.toString(),
              duration: 2000,
            });
          }
        )
        .catch(function (error) {
          that.loading = false;
          console.log(error);
          that.$message.error({
            showClose: true,
            message: "请求出现异常",
            duration: 2000,
          });
        });
    },

    searchbyexcel: function () {
      let that = this;
      // console.log(this.value1.toString()+'---店原始时间哟');
      let datevaluestart = "";
      let datevalueend = "";
      if (this.value1.toString() == "") {
        console.log(this.value1.toString() + "---店没选时间哟");
      } else {
        console.log(this.value1.toString() + "---店已选时间哟");
        datevaluestart = this.dateFormat(this.value1.toString().split(",")[0]);
        datevalueend = this.dateFormat(this.value1.toString().split(",")[1]);
      }
      let params = {
        pageNum: that.page,
        pageSize: 10,
        shopname: that.filters.shopname,
        isdelete: that.filters.isdelete,
        province: this.selprovince,
        city: this.selcity,
        country: this.selcountry,
        email: that.filters.email,
        // value:
        //   this.dateFormat(this.value1.toString().split(",")[0]) +
        //   "," +
        //   this.dateFormat(this.value1.toString().split(",")[1]),
        datestart: datevaluestart,
        dateend: datevalueend,
        companyname: that.filters.companyname,
      };

      // that.loading = true;
      //{"pageNum":1,"pageSize":10,"province":"","city":"","country":"","datestart":"","dateend":""}
      // console.log('看看值是啥'+JSON.stringify(params));
      // const paramsinfo=[];
      // paramsinfo.push(JSON.stringify(params));
      let paramsurl = 'a=1';//没啥作用仅用于后面固定有个&符号，否则接收参数报错的
      if (params.shopname != null) {
        console.log(params.shopname);
        paramsurl += "&shopname=" + params.shopname;
      }
      if (params.isdelete != null) {
        paramsurl += "&isdelete=" + params.isdelete;
      }
      if (params.email != null) {
        paramsurl += "&email=" + params.email;
      }
      if (params.companyname != null) {
        paramsurl += "&companyname=" + params.companyname;
      }
      paramsurl += "&province=" + params.province;
      paramsurl += "&city=" + params.city;
      paramsurl += "&country=" + params.country;
      paramsurl += "&datestart=" + params.datestart;
      paramsurl += "&dateend=" + params.dateend;

      //console.log(params.province+'--');

      console.log(paramsurl + "&rnd=" + Math.random());
      location.href = "/api/shop/exportExcel?" + paramsurl;
    },

    showAddDialog: function (index, row) {
      let that = this;
      this.addFormVisible = true;
      this.addForm = Object.assign({}, row);
    },
    showEditDialog: function (index, row) {
      // console.log(JSON.stringify(row)+'--edit info ');
      let that = this;
      this.editFormVisible = true;
      this.editForm = Object.assign({}, row);
      this.editselectedOptions = [
        TextToCode[row.province].code,
        TextToCode[row.province][row.city].code,
        TextToCode[row.province][row.city][row.country].code,
      ];
    },

    dateFormat(dateData) {
      var date = new Date(dateData);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      const time = y + "-" + m + "-" + d;
      return time;
    },
    addSubmit: function () {
      let that = this;
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.addForm);
          API.add(params).then(function (result) {
            that.loading = true;
            if (0 === result.code) {
              that.loading = false;
              that.$message;
              that.$message.success({
                showClose: true,
                message: "新增成功",
                duration: 2000,
              });
              that.$refs["addForm"].resetFields();
              that.addFormVisible = false;
              that.search();
            } else {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: result.message || "新增失败",
                duration: 2000,
              });
            }
          });
        }
      });
    },
    editSubmit: function () {
      let that = this;
      this.$refs.editForm.validate((valid) => {
        if (valid) {
          let params = Object.assign({}, that.editForm);
          console.log("---修改操作罗-------" + JSON.stringify(params));
          API.update(params).then(function (result) {
            that.loading = true;
            if (0 === result.code) {
              that.loading = false;
              that.$message.success({
                showClose: true,
                message: "修改成功",
                duration: 2000,
              });
              that.$refs["editForm"].resetFields();
              that.editFormVisible = false;
              that.search();
            } else {
              that.loading = false;
              that.$message.error({
                showClose: true,
                message: result.message,
                duration: 2000,
              });
            }
          });
        }
      });
    },
    resetForm(formName) {
      // this[formName] = {};

      this.$nextTick(() => {
        this.$refs[formName].resetFields();
      });
    },
  },
  mounted() {
    this.handleSearch();
  },
};
</script>

<style scoped></style>
